module.exports = __webpack_public_path__ + "media/Aslice_BKG.807727b2.mp4";